import React from 'react';
import { useOfferContext } from '../../../context';
import { GeoBlock } from '../../../components/GeoBlock';
import { UndergroundContainer } from '../UndergroundContainer';
import { RailwayContainer } from '../RailwayContainer';
import { JKNameContainer } from '../JKNameContainer';
import { GeoExtensionLabelContainer } from '../GeoExtensionLabelContainer';
import { SeoSuggestionContainer } from '../SeoSuggestionContainer';

export function GeoContainer() {
  const { geoLabels, tracking } = useOfferContext();

  const handleLabelClick = React.useCallback(
    (label: string) => {
      tracking.trackAddressClick(label);
    },
    [tracking.trackAddressClick],
  );

  return (
    <GeoBlock
      geoLabels={geoLabels}
      onLabelClick={handleLabelClick}
      geoExtensionLabel={<GeoExtensionLabelContainer />}
      seoSuggestion={<SeoSuggestionContainer />}
    >
      <JKNameContainer />
      <UndergroundContainer />
      <RailwayContainer />
    </GeoBlock>
  );
}
